import { Component, computed, inject, linkedSignal, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { DebugModeService } from '../debug-mode.service';

@Component({
    selector: 'rax-set-debug-page',
    imports: [MatFormField, MatInput, MatIcon, MatButton, MatIconButton, FormsModule],
    templateUrl: './set-debug-settings-page.component.html',
})
export class SetDebugSettingsPage {
    private debugModeService = inject(DebugModeService);

    public raxDebugKeyValue = linkedSignal(() => this.debugModeService.debugKey());
    public raxDebugKeyIsSet = signal<boolean>(false);
    public raxDebugKeyIsSaved = computed(() => this.raxDebugKeyValue().length > 0);

    public onGoHomeButtonClick(): void {
        window.location.href = window.location.protocol + '//' + window.location.host;
    }

    public onRaxDebugKeyValueNgModelChange(): void {
        this.raxDebugKeyIsSet.set(false);
    }

    public onSetRaxDebugKeyButtonClick(debugKeyValue: string): void {
        this.raxDebugKeyIsSet.set(true);
        this.debugModeService.setDebugKey(debugKeyValue);
    }

    public onClearRaxDebugKeyButtonClick(): void {
        this.raxDebugKeyIsSet.set(true);
        this.debugModeService.clearDebugKey();
    }
}
